import axios from "axios";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  AreaApi,
  castErrorResult,
  createCatchErrorResult,
  createSuccessResult,
  IExtendableDto,
  IRydeProcess,
  Log,
  SimpleResult,
  simpleResultInvalidApiResponse,
} from "@ryde/shared";

export const useAreasActions = () => {
  const { t } = useTranslation();

  const importFromGeoAreas = useEvent(
    async ({
      geoAreasIds,
    }: {
      geoAreasIds: number[];
    }): Promise<SimpleResult<IExtendableDto[]>> => {
      try {
        const result = await AreaApi.importFromGeoAreas({
          geoAreasIds,
        });

        if (!result) {
          return simpleResultInvalidApiResponse(t);
        }

        if (!result?.success || !result.data) {
          return castErrorResult(result);
        }

        return createSuccessResult(result.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          Log.debug("Axios, request canceled", error);
          return createCatchErrorResult(error, t);
        }

        return createCatchErrorResult(error, t);
      }
    },
  );

  // BULK - PROCESS import areas from geo areas
  const bulkImportFromGeoAreas = useEvent(
    async ({
      geoAreasIds,
    }: {
      geoAreasIds: number[];
    }): Promise<SimpleResult<IRydeProcess>> => {
      try {
        const result = await AreaApi.bulkImportFromGeoAreas({
          geoAreasIds,
        });

        if (!result) {
          return simpleResultInvalidApiResponse(t);
        }

        if (!result?.success || !result.data) {
          return castErrorResult(result);
        }

        return createSuccessResult(result.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          Log.debug("Axios, request canceled", error);
          return createCatchErrorResult(error, t);
        }

        return createCatchErrorResult(error, t);
      }
    },
  );

  return {
    importFromGeoAreas,
    bulkImportFromGeoAreas,
  };
};
